import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ClientesList.css';
import Sidebar from '../../components/Sidebar/Sidebar';
import Topbar from '../../components/Topbar/Topbar';
import {
  LayoutDashboard, FileText, Users, ShoppingBag, BarChart2,
  User, Mail, Calendar, Eye, ChevronLeft, ChevronRight, Filter, Search, ChevronDown, ChevronUp, Plus, MoreVertical, Edit, Trash2, X,
  Map,
  MapPin,
  AlertCircle
} from 'lucide-react';
import { API_URL } from '../../api';
import { mascaraCNPJ, mascaraTelefone, mascaraValor } from '../../utils/mascaras'

const statusColors = {
  'pendente': { bg: '#fef9c3', color: '#b45309' },
  'processando': { bg: '#dbeafe', color: '#2563eb' },
  'cancelado': { bg: '#fee2e2', color: '#e11d48' },
  'enviado': { bg: '#ede9fe', color: '#7c3aed' },
};

function formatDate(dataStr, horaStr = '') {
  if (!dataStr) return '';
  
  const data = new Date(dataStr);
  const dataFormatada = data.toLocaleDateString('pt-BR');
  
  if (horaStr) {
    return `${dataFormatada}, ${horaStr}`;
  }
  
  return dataFormatada;
}

function ClientesList() {
  const [menuAberto, setMenuAberto] = useState(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [filtrosAbertos, setFiltrosAbertos] = useState(true);
  const [filtros, setFiltros] = useState({
    nomeCliente: '',
    numeroCliente: '',
    cnpjCliente: '',
    dataInicial: '',
    dataFinal: '',
    status: '',
  });
  const [filtrosAplicados, setFiltrosAplicados] = useState({});
  const [clientes, setClientes] = useState([]);
  const [totalItens, setTotalItens] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [carregando, setCarregando] = useState(false);
  const [menuAcoesAberto, setMenuAcoesAberto] = useState(null);
  const [clienteDetalhes, setClienteDetalhes] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchClientes() {
      setCarregando(true);
      try {
        let url = `${API_URL}/clientes?page=${paginaAtual}`;
        // Adicionar filtros aplicados na query string
        const params = [];
        if (filtrosAplicados.nomeCliente) params.push(`nome_cliente=${encodeURIComponent(filtrosAplicados.nomeCliente)}`);
        if (filtrosAplicados.numeroCliente) params.push(`numero_cliente=${encodeURIComponent(filtrosAplicados.numeroCliente)}`);
        if (filtrosAplicados.cnpjCliente) params.push(`cnpj_cliente=${encodeURIComponent(filtrosAplicados.cnpjCliente)}`);
        if (filtrosAplicados.dataInicial) params.push(`data_inicial=${encodeURIComponent(filtrosAplicados.dataInicial)}`);
        if (filtrosAplicados.dataFinal) params.push(`data_final=${encodeURIComponent(filtrosAplicados.dataFinal)}`);
        if (filtrosAplicados.status) params.push(`status=${encodeURIComponent(filtrosAplicados.status)}`);
        if (params.length > 0) {
          url += '&' + params.join('&');
        }
        const token = localStorage.getItem('token');
        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await response.json();
        setClientes(data.data || []);
        setTotalItens(data.total || 0);
        setTotalPaginas(data.last_page || 1);
      } catch (e) {
        setClientes([]);
        setTotalItens(0);
        setTotalPaginas(1);
      } finally {
        setCarregando(false);
      }
    }
    fetchClientes(); 
  }, [paginaAtual, filtrosAplicados]);

  const handleChangeFiltro = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handlePesquisar = (e) => {
    e.preventDefault();
    setFiltrosAplicados({ ...filtros });
    setPaginaAtual(1);
  };

  const handleLimpar = () => {
    const filtrosLimpos = {
      nomeCliente: '',
      numeroCliente: '',
      cnpjCliente: '',
      dataInicial: '',
      dataFinal: '',
      status: '',
    };
    setFiltros(filtrosLimpos);
    setFiltrosAplicados(filtrosLimpos);
    setPaginaAtual(1);
  };

  const mudarPagina = (novaPagina) => {
    if (novaPagina >= 1 && novaPagina <= totalPaginas) {
      setPaginaAtual(novaPagina);
    }
  };

  // Gerar array de páginas para exibir
  const gerarPaginas = () => {
    const paginas = [];
    const maxPaginasVisiveis = 5;
    if (totalPaginas <= maxPaginasVisiveis) {
      for (let i = 1; i <= totalPaginas; i++) {
        paginas.push(i);
      }
    } else {
      if (paginaAtual <= 3) {
        for (let i = 1; i <= 4; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      } else if (paginaAtual >= totalPaginas - 2) {
        paginas.push(1);
        paginas.push('...');
        for (let i = totalPaginas - 3; i <= totalPaginas; i++) {
          paginas.push(i);
        }
      } else {
        paginas.push(1);
        paginas.push('...');
        for (let i = paginaAtual - 1; i <= paginaAtual + 1; i++) {
          paginas.push(i);
        }
        paginas.push('...');
        paginas.push(totalPaginas);
      }
    }
    return paginas;
  };

  const handleAbrirMenuAcoes = (clienteId) => {
    setMenuAcoesAberto(clienteId);
  };
  const handleFecharMenuAcoes = () => {
    setMenuAcoesAberto(null);
  };

  // Função para abrir modal de detalhes
  const handleVerDetalhes = (cliente) => {
    //setClienteDetalhes(cliente);
    setMenuAcoesAberto(null);
  };
  // Função para fechar modal
  const handleFecharModalDetalhes = () => {
    setClienteDetalhes(null);
  };

  return (
    <div className="dashboard-root">
      <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
      <div className="main-content">
        <Topbar
          setMenuAberto={setMenuAberto}
          titulo="Clientes"
          
        />
        <div className="conteudo-dashboard clientes-listagem">
          <div className="card-page-main">
            
            <div className="card-page-main-header">
              <div className="card-page-main-header-title">
                <h2>Clientes</h2>
              </div>
            
            </div>
            {/* Filtros de Pesquisa - Collapse */}
            <div className="filtros-collapse">
              <div className="filtros-collapse-header" onClick={() => setFiltrosAbertos((v) => !v)}>
                <Filter size={15} style={{ marginRight: 8 }} />
                <span>Filtros de Pesquisa</span>
                <span className="filtros-collapse-arrow">
                  {filtrosAbertos ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </span>
              </div>
              {filtrosAbertos && (
                <form className="filtros-form" onSubmit={handlePesquisar}>
                  <div className="filtros-grid">
                    <div className="filtro-item">
                      <label>Nome do Cliente</label>
                      <input
                        type="text"
                        name="nomeCliente"
                        placeholder="Digite o nome do cliente..."
                        value={filtros.nomeCliente}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>Número do Cliente</label>
                      <input
                        type="text"
                        name="numeroCliente"
                        placeholder="Digite o número do cliente..."
                        value={filtros.numeroCliente}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>CNPJ do Cliente</label>
                      <input
                        type="text"
                        name="cnpjCliente"
                        placeholder="Digite o CNPJ..."
                        value={filtros.cnpjCliente}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>Data Inicial</label>
                      <input
                        type="date"
                        name="dataInicial"
                        placeholder="dd/mm/aaaa"
                        value={filtros.dataInicial}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>Data Final</label>
                      <input
                        type="date"
                        name="dataFinal"
                        placeholder="dd/mm/aaaa"
                        value={filtros.dataFinal}
                        onChange={handleChangeFiltro}
                      />
                    </div>
                    <div className="filtro-item">
                      <label>Status</label>
                      <select
                        name="status"
                        value={filtros.status}
                        onChange={handleChangeFiltro}
                      >
                        <option value="">Todos os status</option>
                        <option value="pendente">Pendente</option>
                        <option value="processando">Processando</option>
                        <option value="enviado">Enviado</option>
                        <option value="cancelado">Cancelado</option>
                      </select>
                    </div>
                  </div>
                  <div className="filtros-botoes">
                    <button type="submit" className="btn-pesquisar">
                      <Search size={16} style={{ marginRight: 6 }} /> Pesquisar
                    </button>
                    <button type="button" className="btn-limpar" onClick={handleLimpar}>
                      Limpar Filtros
                    </button>
                  </div>
                </form>
              )}
            </div>
            <div className="cards-list">
              {carregando ? (
                <div style={{ padding: 32, textAlign: 'center', color: '#888' }}>Carregando clientes...</div>
              ) : clientes.length === 0 ? (
                <div style={{ padding: 32, textAlign: 'center', color: '#888' }}>Nenhum cliente encontrado.</div>
              ) : (
                clientes.map(cliente => (
                  <div className="card-list" key={cliente.id}>
                    <div className="card-list-header">
                      <span className="cliente-id">{cliente.id}</span>
                      <span className="cliente-nome">{cliente.nome}</span>
                      <div className="card-list-acoes">
                        <button
                          className="card-list-acoes-btn"
                          onClick={() => menuAcoesAberto === cliente.id ? handleFecharMenuAcoes() : handleAbrirMenuAcoes(cliente.id)}
                          tabIndex={0}
                          aria-label="Ações do cliente"
                        >
                          <MoreVertical size={20} />
                        </button>
                        {menuAcoesAberto === cliente.id && (
                          <div className="card-list-menu-popover" onMouseLeave={handleFecharMenuAcoes}>
                            <button className="card-list-menu-item" onClick={() => handleVerDetalhes(cliente)}> 
                              <Eye size={16} style={{ marginRight: 8 }} /> Ver Detalhes
                            </button>
                            <button className="card-list-menu-item" onClick={() => { handleFecharMenuAcoes(); navigate(`/clientes/editar/${cliente.id}`); }}>
                              <Edit size={16} style={{ marginRight: 8 }} /> Editar
                            </button>
                            <button className="card-list-menu-item card-list-menu-excluir" onClick={() => { handleFecharMenuAcoes(); /* ação excluir */ }}>
                              <Trash2 size={16} style={{ marginRight: 8 }} /> Excluir
                            </button>
                            
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="card-list-body">
                      <div className="cliente-card-body-1">
                        <div className='cliente-endereco'>
                          <MapPin size={15} style={{ marginRight: 5 }} /> {cliente.endereco}, {cliente.cidade} - {cliente.estado}
                        </div>
                        {
                          cliente.valor_em_atraso > 0 && (
                            <div className='cliente-valor-atraso'>
                              <AlertCircle size={15} style={{ marginRight: 5 }} />
                              Em atraso - {mascaraValor(cliente.valor_em_atraso)}
                            </div>
                          )
                        }
                        
                      </div>
                      <div className="cliente-card-body-2">
                      <div className="cliente-info">
                        <span className="cliente-cnpj">
                          CNPJ: {mascaraCNPJ(cliente.documento)}
                        </span>
                      </div>
                      <div className="cliente-info">
                        <span className="cliente-telefone">
                          Tel.: {mascaraTelefone(cliente.telefone)}
                        </span>
                      </div>
                    
                      <div className="cliente-itens">
                        10 pedidos (mês atual)
                      </div>
                    </div>
                      
                      
                    </div>
                    
                  </div>
                ))
              )}
            </div>
            
            {/* Componente de Paginação */}
            {totalPaginas > 1 && (
              <div className="paginacao-container">
                <div className="paginacao-info">
                  <span>
                    Mostrando {(paginaAtual - 1) * 10 + 1} a {Math.min(paginaAtual * 10, totalItens)} de {totalItens} clientes
                  </span>
                </div>
                <div className="paginacao-controles">
                  <button
                    className="paginacao-btn"
                    onClick={() => mudarPagina(paginaAtual - 1)}
                    disabled={paginaAtual === 1}
                  >
                    <ChevronLeft size={16} />
                    Anterior
                  </button>
                  
                  <div className="paginacao-numeros">
                    {gerarPaginas().map((pagina, index) => (
                      <button
                        key={index}
                        className={`paginacao-numero ${pagina === paginaAtual ? 'ativo' : ''} ${pagina === '...' ? 'separador' : ''}`}
                        onClick={() => typeof pagina === 'number' && mudarPagina(pagina)}
                        disabled={pagina === '...'}
                      >
                        {pagina}
                      </button>
                    ))}
                  </div>
                  
                  <button
                    className="paginacao-btn"
                    onClick={() => mudarPagina(paginaAtual + 1)}
                    disabled={paginaAtual === totalPaginas}
                  >
                    Próxima
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Modal de Detalhes do Cliente */}
      {clienteDetalhes && (
        <div className="modal-detalhes-overlay">
          <div className="modal-detalhes">
            <button className="modal-detalhes-fechar" onClick={handleFecharModalDetalhes} aria-label="Fechar">
              <X size={22} />
            </button>
            <h2 className="modal-detalhes-titulo">
              Detalhes do Cliente <span className="modal-detalhes-numero">#{clienteDetalhes.numero_cliente}</span>
            </h2>
            <div className="modal-detalhes-row">
              <div className="modal-detalhes-col">
                <div className="modal-detalhes-label">Informações do Cliente</div>
                <div><b>Nome:</b> {clienteDetalhes.cliente?.nome}</div>
                <div><b>Email:</b> {clienteDetalhes.cliente?.email}</div>
                <div><b>CNPJ:</b> {clienteDetalhes.cliente?.documento}</div>
              </div>
              <div className="modal-detalhes-col" style={{ minWidth: 180 }}>
                <div className="modal-detalhes-label">Status do Cliente</div>
                <span className="modal-detalhes-status" style={{ background: statusColors[clienteDetalhes.status]?.bg, color: statusColors[clienteDetalhes.status]?.color }}>
                  {clienteDetalhes.status.charAt(0).toUpperCase() + clienteDetalhes.status.slice(1)}
                </span>
              </div>
            </div>
            <div className="modal-detalhes-label" style={{ marginTop: 18 }}>Itens do Cliente</div>
            <div className="modal-detalhes-tabela-wrapper">
              <table className="modal-detalhes-tabela">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Qtd</th>
                    <th>Preço Unit.</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {clienteDetalhes.itens?.map((item, idx) => (
                    <tr key={item.id || idx}>
                      <td>{item.produto?.nome}</td>
                      <td>{item.quantidade}</td>
                      <td>R$ {Number(item.preco_unitario).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                      <td><b>R$ {Number(item.subtotal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</b></td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'right', fontWeight: 500 }}>Subtotal:</td>
                    <td><b>R$ {Number(clienteDetalhes.valor_total).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</b></td>
                  </tr>
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'right', fontWeight: 700, fontSize: 16 }}>Total:</td>
                    <td style={{ color: '#16a34a', fontWeight: 700, fontSize: 16 }}>R$ {Number(clienteDetalhes.valor_total).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="modal-detalhes-row" style={{ marginTop: 18 }}>
              <div className="modal-detalhes-col">
                <div className="modal-detalhes-label">Data:</div>
                <div>{formatDate(clienteDetalhes.data_cliente, clienteDetalhes.hora_cliente)}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ClientesList;
